var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowRightWhite = function SvgIconArrowRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M7.3 4.37a.984.984 0 0 1 0-1.415 1.04 1.04 0 0 1 1.447 0l6.803 6.646c.6.586.6 1.536 0 2.122l-6.803 6.646c-.4.39-1.047.39-1.447 0a.984.984 0 0 1 0-1.414l6.44-6.293z"
  })));
};
export default SvgIconArrowRightWhite;